export const YES = 'Yes';
export const NO = 'No';
export const TRUE = 'true';
export const FALSE = 'false';
